import { render, staticRenderFns } from "./bank-accounts-modal.vue?vue&type=template&id=0521f30d&scoped=true&"
import script from "./bank-accounts-modal.vue?vue&type=script&lang=js&"
export * from "./bank-accounts-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0521f30d",
  null
  
)

export default component.exports